/**
 * First and last name joined by a space. The last name is optional, so it can be missing; this
 * leaves it out instead of printing "Asha undefined" or "Asha null".
 */
export const fullName = (firstName?: string | null, lastName?: string | null): string =>
  [firstName, lastName]
    .map((part) => (part ?? "").trim())
    .filter((part) => part !== "" && part.toLowerCase() !== "null" && part !== "undefined")
    .join(" ");
